module.exports = __webpack_public_path__ + "img/icon-gen-adminuserlogin.be794b72.png";